import {
  APP_START_FRONTEND,
  APP_PAGES_DATA,
  APP_SET_METADATA,
  APP_SET_COOKIE_CHOICE,
  APP_SET_LOCALE,
  APP_SET_LOCALISATION,
  APP_TOGGLE_ACTIVITY_CARD_FOCUS,
  APP_RELEASE_ACTIVITY_CARD_FOCUS,
  TRACK_PREV_PAGE,
  TOGGLE_MODAL_OVERLAY,
  TOGGLE_ONLINE_STATUS,
} from 'js/store/app/App.actions.js';

const urlParams = new URLSearchParams(window.location.search);
const initState = {
  startFrontend: false,
  pagesData: {},
  meta: {},
  cookieChoice: false,
  locale: urlParams.get('locale') === 'es' ? 'es' : 'en',
  translations: {},
  activityCardFocus: false,
  releaseActivityCardFocus: false,
  previousLocation: null,
  modal: false,
  isOnline: true,
};

const app = (state = initState, action) => {
  let nextState = {};

  switch (action.type) {
    case TOGGLE_ONLINE_STATUS:
      nextState.isOnline = action.payload;
      return { ...state, ...nextState };

    case TOGGLE_MODAL_OVERLAY:
      nextState.modal = action.payload;
      return { ...state, ...nextState };

    case APP_RELEASE_ACTIVITY_CARD_FOCUS:
      nextState.releaseActivityCardFocus = action.payload;
      return { ...state, ...nextState };

    case TRACK_PREV_PAGE:
      nextState.previousLocation = action.payload;
      return { ...state, ...nextState };

    case APP_START_FRONTEND:
      nextState.startFrontend = true;
      return { ...state, ...nextState };

    case APP_PAGES_DATA:
      nextState.pagesData = {
        ...action.payload,
      };
      return { ...state, ...nextState };

    case APP_SET_METADATA:
      nextState.meta = action.payload;
      return { ...state, ...nextState };

    case APP_SET_COOKIE_CHOICE:
      nextState.cookieChoice = action.payload;
      return { ...state, ...nextState };

    case APP_SET_LOCALE:
      nextState.locale = action.payload;
      return { ...state, ...nextState };

    case APP_SET_LOCALISATION:
      nextState.translations = action.payload;
      return { ...state, ...nextState };

    case APP_TOGGLE_ACTIVITY_CARD_FOCUS:
      nextState.activityCardFocus = action.payload;
      return { ...state, ...nextState };
  }
  return state;
};

export default app;
